import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { ENV_QUERY_KEY } from '../../../context/env-context';
import { useSite } from '../../../context/page-context';
import { SETTINGS_QUERY_KEY } from '../../../context/settings-context';

// Refreshes the settings/env caches when the Vue host bumps `revision` on a modal close.
export function useVueBridgeRefresh(revision: number) {
  const queryClient = useQueryClient();
  const site = useSite();
  const first = useRef(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: `revision` only re-runs the effect.
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    void queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
    void queryClient.invalidateQueries({
      queryKey: [ENV_QUERY_KEY, site.siteId, site.siteEnv],
    });
  }, [revision, queryClient, site.siteId, site.siteEnv]);
}
